import { __decorate } from "tslib";
import { customElement } from "@microsoft/fast-element";
import { Accordion, AccordionTemplate as template } from "@microsoft/fast-foundation";
import { AccordionStyles as styles } from "./accordion.styles";
export * from "../accordion-item/index";
/**
 * The FAST Accordion Element. Implements {@link @microsoft/fast-foundation#Accordion},
 * {@link @microsoft/fast-foundation#AccordionTemplate}
 *
 *
 * @public
 * @remarks
 * HTML Element: \<fast-accordion\>
 */
let FASTAccordion = class FASTAccordion extends Accordion {
};
FASTAccordion = __decorate([
    customElement({
        name: "fast-accordion",
        template,
        styles,
    })
], FASTAccordion);
export { FASTAccordion };
/**
 * Styles for Accordion
 * @public
 */
export const AccordionStyles = styles;
